export const FormControl = ({ children, className = "" }) => {
    return (
        <div className={`w-full md:w-64 lg:w-72 flex flex-col gap-y-3 ${className}`}>
            {children}
        </div>
    );
};